module.exports = __webpack_public_path__ + "static/media/maske.0374423e.jpg";